const Vertex = function (name) {
    this.connections = [];
    this.index= -1;
    this.lowlink = -1;
    Object.defineProperty(this, "name", {
        set: () => {},
        get: () => name
    });
};
Vertex.prototype.connect = function(vertex) {
    this.connections.push(vertex);
};
Vertex.prototype.equals = function(vertex) {
    return (this.name == vertex.name);
};

const Graph = function () {
    this.vertices = [];
    this.vertices_by_name = {};
};
Graph.prototype.add_vertex = function(name) {
    if (name in this.vertices_by_name) {
        return;
    }
    var vertex = new Vertex(name);
    this.vertices.push(vertex);
    this.vertices_by_name[name] = vertex;
};
Graph.prototype.connect_vertex = function(name_v, name_w) {
    if (!(name_v in this.vertices_by_name)) {
        this.add_vertex(name_v);
    }
    if (!(name_w in this.vertices_by_name)) {
        this.add_vertex(name_w);
    }
    this.vertices_by_name[name_v].connect(this.vertices_by_name[name_w]);
};

const VertexStack = function () {
    this.vertices = [];
    this.vertices_by_name = {};
};
VertexStack.prototype.contains = function(vertex) {
    return (vertex.name in this.vertices_by_name);
};
VertexStack.prototype.push = function(vertex) {
    if (vertex.name in this.vertices_by_name) {
        return;
    }
    this.vertices.push(vertex);
    this.vertices_by_name[vertex.name] = vertex;
};
VertexStack.prototype.pop = function() {
    var vertex = this.vertices.pop();
    if (vertex === undefined) {
        return;
    }
    delete this.vertices_by_name[vertex.name];
    return vertex;
};
VertexStack.prototype.has_vertices = function() {
    return (this.vertices.length > 0);
};

const Tarjan = function () {
    const graph = new Graph();
    const stack = new VertexStack();

    Object.defineProperty(this, "graph", {
        set: () => {},
        get: () => graph
    });

    const strongconnect = (state, v) => {
        v.index = state.index;
        v.lowlink = state.index;
        state.index += 1;
        stack.push(v);

        for (let w of v.connections){
            if (w.index < 0){
                strongconnect(state, w);
                v.lowlink = Math.min(v.lowlink, w.lowlink);
            } else if (stack.contains(w)) {
                v.lowlink = Math.min(v.lowlink, w.index);
            }
        }

        if (v.lowlink === v.index){
            let vertices = [];
            let w = null;
            if (stack.has_vertices()) {
                do {
                    w = stack.pop();
                    vertices.push(w);
                } while (!v.equals(w));
            }
            if (vertices.length > 0){
                state.scc.push(vertices);
            }
        }
    };

    this.run = () => {
        var state = {scc: [], index: 0}; // state with index and strongly connected component
        for (let vertex of graph.vertices){
            if (vertex.index < 0) {
                strongconnect(state, vertex);
            }
        }
        return state.scc;
    };
};

/*

window.onload = function() {
    var tarjan = new Tarjan();

    tarjan.graph.add_vertex("0");
    tarjan.graph.add_vertex("1");
    tarjan.graph.add_vertex("2");
    tarjan.graph.add_vertex("3");
    tarjan.graph.add_vertex("4");
    tarjan.graph.add_vertex("5");
    tarjan.graph.add_vertex("6");
    tarjan.graph.add_vertex("7");
    tarjan.graph.add_vertex("8");
    tarjan.graph.add_vertex("9");
    tarjan.graph.add_vertex("10");
    tarjan.graph.add_vertex("11");
    tarjan.graph.add_vertex("12");

    tarjan.graph.connect_vertex("0", "1");
    tarjan.graph.connect_vertex("0", "5");
    tarjan.graph.connect_vertex("2", "0");
    tarjan.graph.connect_vertex("2", "3");
    tarjan.graph.connect_vertex("3", "2");
    tarjan.graph.connect_vertex("3", "5");
    tarjan.graph.connect_vertex("4", "2");
    tarjan.graph.connect_vertex("4", "2");
    tarjan.graph.connect_vertex("5", "4");
    tarjan.graph.connect_vertex("6", "0");
    tarjan.graph.connect_vertex("6", "9");
    tarjan.graph.connect_vertex("7", "6");
    tarjan.graph.connect_vertex("7", "8");
    tarjan.graph.connect_vertex("8", "7");
    tarjan.graph.connect_vertex("8", "9");
    tarjan.graph.connect_vertex("9", "10");
    tarjan.graph.connect_vertex("9", "11");
    tarjan.graph.connect_vertex("10", "12");
    tarjan.graph.connect_vertex("11", "4");
    tarjan.graph.connect_vertex("11", "12");
    tarjan.graph.connect_vertex("12", "9");

    var scc = tarjan.run();
    console.log(scc);
};
*/

export default Tarjan;
